export default __webpack_public_path__ + "static/media/ECR.f92a5580.png";